import { ApolloProvider } from '@apollo/client';
import { once } from '@lingoda/utils';
import { createMonolithClient } from './createMonolithClient';

export const MonolithGraphQLProvider = (props: React.PropsWithChildren) => {
    return <ApolloProvider client={getMonolithClient()}>{props.children}</ApolloProvider>;
};

// StrictMode re-mounts hooks, so memoizing this with `useMemo` would build two clients.
const getMonolithClient = once(createMonolithClient);
